"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import randomColor from "randomcolor";
import { getRandomColor } from "@/utils/color";
import { FaUserEdit } from "react-icons/fa";
import { NormalStyles, NormalStylesWithClick } from "@/layouts/styles/ssr.style";
import { FaClock } from "react-icons/fa6";
import { definitions } from "@/services/metruyenvl";
import { formatDistanceToNow } from "date-fns";
import { vi } from "date-fns/locale";
import BookStatAndAction from "./book-action-stat";
import CoverImageDetail from "./cover-image-detail";
import { RootState } from "@/redux/store";
import { BookData } from "@/redux/reducers/book.reducer";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";
function BookInfo({ slug }: { slug: string }) {
    const router = useRouter();

    const bookData: BookData = useSelector((state: RootState) => state.bookReducer.map[slug as string]);

    return (
        <div className="flex md:flex-row flex-col p-4 md:p-0 gap-x-8">
            <div className="pt-4 pl-4">
                <CoverImageDetail book={bookData?.detail} />
            </div>
            <div>
                <div className="text-center md:mt-0 mt-2 md:text-start">{bookData?.detail?.name ? <h1 className="lg:text-xl text-sm font-semibold">{bookData?.detail?.name}</h1> : <Skeleton.Input active size="small" className="lg:text-xl text-sm font-semibold" block />}</div>
                <div
                    className="flex items-center lg:text-xl text-sm gap-x-2 md:mt-0 mt-2 justify-center md:justify-start cursor-pointer"
                    style={{ color: "#6B727F" }}
                    onClick={() => {
                        router.push(`/tac-gia/${bookData?.detail?.author?.slug}`);
                    }}
                >
                    <FaUserEdit color="#6B727F" /> {bookData?.detail?.author?.name ? bookData?.detail?.author?.name : <Skeleton active title={false} paragraph={{ rows: 1, width: ["50%"] }} />}
                </div>
                <div className="flex items-center gap-x-2 mt-2 md:justify-start justify-center">
                    <FaClock color="rgb(107 114 128)" />
                    {bookData?.detail?.updated_time ? (
                        <NormalStyles>
                            {formatDistanceToNow((bookData?.detail?.updated_time ?? 0) * 1000, {
                                locale: vi,
                                addSuffix: true,
                            })}
                        </NormalStyles>
                    ) : (
                        <Skeleton active title={false} paragraph={{ rows: 1, width: ["20%"] }} />
                    )}
                </div>

                <div className="flex items-center gap-x-4 flex-wrap mt-5 text-sm gap-y-2 md:justify-start justify-center">
                    {bookData?.detail?.tags ? (
                        <>
                            {bookData?.detail?.tags?.map((item: any, index: number) => {
                                let bgColor = getRandomColor();
                                return (
                                    <div
                                        onClick={() => {
                                            router.push(`/the-loai/${item.slug}/${item.id}`);
                                        }}
                                        className="border border-solid p-1 pr-2 pl-2 rounded-3xl cursor-pointer md:p-2 md:pr-3 md:pl-3"
                                        style={{ borderColor: `${bgColor}`, color: `${bgColor}` }}
                                        key={index}
                                    >
                                        {item.name}
                                    </div>
                                );
                            })}
                        </>
                    ) : (
                        <>
                            <Skeleton.Button size="large" /> <Skeleton.Button size="large" /> <Skeleton.Button size="large" />
                        </>
                    )}
                </div>
                <BookStatAndAction slug={bookData?.detail?.slug as string}></BookStatAndAction>
            </div>
        </div>
    );
}

export const getStaticProps = () => {
    const color = randomColor();
    return {
        props: {
            color: color,
        },
    };
};

export default BookInfo;
